export default class extends HTMLElement {

  static get observedAttributes() {
    return ['service'];
  }

  constructor() {
    super();
    console.log('Init DSBWorkspace');
    //this._setupSwipe();
    this.tabs = {};
    this.global_loader = true;
  }

  init()
  {
     this.setAttribute(`id`, 'dsb-workspace_'+this._createUUID());
  }

  get settings() {

      let settings = this.getAttribute('settings');
      if(typeof settings !== 'object')
      {
        settings = JSON.parse(settings);
      }
      return settings;
  }

  set settings(newValue){
      this.setAttribute('settings', newValue);
  }

  render()
  {
    return this._render();
  }

  setTab(name, content, active=false, render=true){
      this.tabs[name] = {'name':name, 'content':content, 'active': active};
      if(render)
      {
        return this._render();
      }
      return true;
  }

  removeTab(name, render=true)
  {
      if(name in this.tabs)
      {
        delete this.tabs[name];
        if(render)
        {
          return this._render();
        }
        return true;
      }
      return false;
  }

  reset()
  {
      this.tabs = {};
      this.innerHTML = ``;
      return true;
  }

  switchTab(name)
  {
    if(name in this.tabs)
    {
      let thisTab = document.getElementById(this.tabs[name].id);
      console.log(this.tabs[name].id);
      console.log(thisTab);
      thisTab.dispatchEvent(new MouseEvent("click", {
          "view": window,
          "bubbles": true,
          "cancelable": false
      }));
      return true;
    }
    return false;
  }

  getTab(id)
  {
    try
    {
      return this.tabs[id];
    }
    catch(ex)
    {
        throw ex;
    }
  }

  setDSBClient(dsbClient){
      this.dsbClient=dsbClient;
  }

  connectedCallback()
  {
    return this._render();
  }

  attributeChangedCallback(name, oldValue, newValue)
  {
    console.log('attributeChangedCallback..'+name);
    return this._render();
  }

  _createUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  _setupSwipe()
  {

      let _this = this;
      const pStart = { x: 0, y: 0 };
      const pCurrent = { x: 0, y: 0 };
      const cards = document.querySelectorAll(".card");
      const main = document.querySelector("body > div");
      let isLoading = false;
      var refresh_panel = false;

      let loadPulldown = function() {
        isLoading = true;

        // Pulldown refresh
        if(!refresh_panel)
        {
          refresh_panel = document.createElement("div");
          refresh_panel.classList='pulldown-refresh show';
          refresh_panel.innerHTML = `<maa-spinner type="inline-small"></maa-spinner>`;
          _this.prepend(refresh_panel);
          _this.global_loader = false;
          _this._render();
          /**
          setTimeout(() => {
            refresh_panel.style.transform = `translateY(100px)`;
          }, 2000);
          */
        }

        /**
        main.style.transform = `translateY(0px)`;
        setTimeout(() => {
          main.style.transform = `translateY(-100px)`;
          isLoading = false;
          for (const card of cards) {
            card.style.transform = `rotateX(0deg)`;
          }
        }, 2000);
        */
      };

      let lastPosition = null
      this.addEventListener("touchstart", e => {
        try
        {
          if (typeof e["targetTouches"] !== "undefined") {
            let touch = e.targetTouches[0];
            pStart.x = touch.screenX;
            pStart.y = touch.screenY;
          } else {
            pStart.x = e.screenX;
            pStart.y = e.screenY;
          }
        }
        catch(ex)
        {
          console.error('DSBWorkspace-touchstart:: Error occured in detail',ex,e);
        }
      });
      this.addEventListener("touchmove", e => {
        try
        {
          if (typeof e["changedTouches"] !== "undefined") {
            let touch = e.changedTouches[0];
            pCurrent.x = touch.screenX;
            pCurrent.y = touch.screenY;
          } else {
            pCurrent.x = e.screenX;
            pCurrent.y = e.screenY;
          }
          let changeY = pStart.y < pCurrent.y ? Math.abs(pStart.y - pCurrent.y) : 0;
          //const rotation = changeY < 100 ? changeY * 30 / 100 : 30;
          if (_this.scrollTop === 0 && !isLoading) {
            if (changeY > 100) loadPulldown();
            //for (const card of cards) card.style.transform = `rotateX(${rotation}deg)`;
          }
          /**
          if(thisPosition+5 < lastPosition)
          {
            // Pulldown refresh
            var refresh_panel = document.createElement("div");
            refresh_panel.class='pulldown-refresh fadeIn';
            refresh_panel.innerHTML = `<maa-spinner id="`+this.id+`_spinner"></maa-spinner>`;
            this.prepend(refresh_panel);
            e.preventDefault();
          }
          */
        }
        catch(ex)
        {
          console.error('DSBWorkspace-touchmove:: Error occured in detail',ex,e);
        }
      });
      this.addEventListener("touchend", e => {
        try
        {
          if (_this.scrollTop === 0 && !isLoading) {
            //for (const card of cards) card.style.transform = `rotateX(0deg)`;
            console.error('Ok.. at top and no loading...');

          }
        }
        catch(ex)
        {
          console.error('DSBWorkspace-touchend:: Error occured in detail',ex,e);
        }
      });
  }

  async _render()
  {
    let has_tabs = (Object.keys(this.tabs).length>0?true:false);
    if(has_tabs)
    {
      this.innerHTML = `<maa-spinner id="`+this.id+`_spinner"></maa-spinner>`;
    }

    var nav_panel = document.createElement("nav");
    var tabs_panel = document.createElement("ul");

    var tab_count = 0;
    var has_active = false;

    var on_click = function()
    {
      // Set active item
      let menu_li = this.parentElement.querySelectorAll(`li`);
      if(menu_li !== undefined || menu_li.length > 0)
      {
        for(let i = 0; i < menu_li.length; i++)
        {
          if(menu_li[i].classList.contains('active'))
          {
            menu_li[i].classList.remove('active');
            let thisSection = document.getElementById(menu_li[i].id+'_section');
            thisSection.style.display='none';
          }
        }
      }
      this.classList.add('active');
      let thisSection = document.getElementById(this.id+'_section');
      thisSection.style.display='block';
    };

    if(has_tabs)
    {
      for(var tab in this.tabs)
      {
        let tab_id = this.id+`_tab_`+tab;
        let _link = document.createElement("li");
        _link.innerHTML = this.tabs[tab].name;
        _link.setAttribute(`data-controller_id`, this.id);
        _link.setAttribute(`data-task_id`, tab);
        _link.setAttribute(`data-has_parts`, false);
        _link.onclick = on_click;
        _link.setAttribute(`id`, tab_id);
        if(this.tabs[tab].active)
        {
          _link.classList.add('active');
        }

        this.tabs[tab].id = tab_id;

        tabs_panel.append(_link);
        let section_panel = document.createElement("section");
        section_panel.setAttribute(`id`, tab_id+'_section');
        section_panel.innerHTML = ``;
        if(`content` in this.tabs[tab])
        {
          if(this.tabs[tab].content instanceof HTMLElement)
          {
            section_panel.append(this.tabs[tab].content);
          }
          else
          {
            section_panel.innerHTML = this.tabs[tab].content;
          }
        }

        if(this.tabs[tab].active && !has_active)
        {
          has_active=true;
        }
        else
        {
          section_panel.style.display='none';
        }

        this.append(section_panel);
        tab_count++;
      }

      if(has_active)
      {
        let spinner = document.getElementById(this.id+'_spinner');
        spinner.remove();
      }

      if(tab_count > 1)
      {
        nav_panel.append(tabs_panel);
        this.prepend(nav_panel);
      }
    }
    return;
  }
}


